<template>
  <v-btn
    :class="[isBtnDFlex ? 'v-btn--block' : '', { 'disable-events': disabled }]"
    round
    large
    :color="colorCode"
    @click="handleClick"
    :dark="isDark"
    :outline="hasOutline"
    :flat="disabled"
    :disabled="disabled"
  >
    <span><slot /></span>
  </v-btn>
</template>

<script>
export default {
  props: {
    isDark: {
      type: Boolean,
      default: false
    },
    hasOutline: {
      type: Boolean,
      default: false
    },
    colorCode: {
      type: String,
      default: 'black'
    },
    autoSpread: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isBtnDFlex: this.autoSpread && this.$vuetify.breakpoint.xs
    };
  },
  methods: {
    // `click`イベントを発行
    handleClick(ev) {
      this.$emit('click', ev);
    }
  }
};
</script>

<style lang="stylus">
.instagram
  color: #e4405f;
.black
  color: black;
.disable-events
  pointer-events: none
  color: white !important
  background-color: #ECEBE4 !important
</style>
